const buttons = document.querySelectorAll(
	'.wp-block-button__link--has-click-script'
);

const clickButton = (e) => {
	const buttonParent = e.currentTarget?.parentElement;

	if (!buttonParent) {
		return;
	}

	const scriptWrapper = buttonParent?.nextElementSibling;

	if (
		!buttonParent ||
		!scriptWrapper.classList.contains(
			'wp-block-button__click-script-wrapper'
		)
	) {
		return;
	}

	const scripts = scriptWrapper.querySelectorAll('script');

	scripts.forEach((oldScript) => {
		const newScript = document.createElement('script');
		newScript.type = 'text/javascript';

		oldScript.remove();

		if (oldScript.src) {
			newScript.src = oldScript.src;
		} else {
			newScript.textContent = oldScript.textContent;
		}

		scriptWrapper.appendChild(newScript);
	});
};

buttons.forEach((button) => {
	button.addEventListener('click', clickButton);
});
